import {Row, Col, Card, Drawer, Grid, Divider} from 'antd';
import Widgets from '../components/WidgetContainer';
import React, { useState } from 'react';

import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { Link, useNavigate } from 'react-router-dom';  // or 'react-router-dom', if you're using that
import { Tree } from 'antd';
import {ChevronsDown, ChevronRight, LayoutGrid, Shapes, Boxes} from 'lucide-react'
import { Popover, Tag } from 'antd';

const { useBreakpoint } = Grid;

const MenuTag = ({ title, childrenLinks = [] }) => {
  return (
    <Popover
      title={title}
      trigger="hover"
      content={
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {childrenLinks.map((child, index) => (
            <Link
              key={index}
              to={child.url}
              style={{ color: 'blue', textDecoration: 'none' }}
            >
              {child.title}
            </Link>
          ))}
        </div>
      }
    >
      <div className={'bg-transparent border border-gray-400 rounded-full py-1 px-4'} color="blue" style={{ cursor: 'pointer' }}>
        {title}
      </div>
    </Popover>
  );
};


const LinkTree = ({ data = [] }) => {
  const navigate = useNavigate();

  // Keep track of selected node to handle double-click navigation
  const [selectedNode, setSelectedNode] = React.useState(null);

  // Recursively transform the user-supplied data into AntD's treeData format
  const transformData = (nodes, prefix = '0') => {
    return nodes.map((node, index) => {
      const key = `${prefix}-${index}`;

      const handleClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (node.url){
          navigate(node.url);
        }
      }

      if (node.url) {
        // Leaf node
        return {
          key,
          url: node.url, // Store URL in node data
          icon: <ChevronRight style={{ color: 'blue' }} size={18} className="mt-1" onClick={handleClick} />,
          title: (
            <span
              className="text-blue-600 cursor-pointer"
              onClick={handleClick}
            >
              {node.title}
            </span>
          ),
        };
      }

      // Parent node with children
      return {
        key,
        title: <span className="text-black">{node.title}</span>,
        children: transformData(node.children || [], key),
      };
    });
  };

  const treeData = transformData(data);

  const onSelect = (selectedKeys, info) => {
    const node = info.node;

    if (node.url) {
      if (selectedNode === node.key) {
        // If the same node is selected twice, navigate to the URL
        navigate(node.url);
      } else {
        // First click - just select the node
        setSelectedNode(node.key);
      }
    }

    console.log('Selected node info:', info);
  };

  return (
    <Tree
      treeData={treeData}
      defaultExpandAll
      onSelect={onSelect}
      showLine
      showIcon
      icon={null}
      switcherIcon={<ChevronsDown style={{ color: 'blue' }} />}
      selectedKeys={selectedNode ? [selectedNode] : []}
    />
  );
};


const CompanyLinks = {title: 'Company',
    children: [
        {title: 'Company Page', url: '/company'},
        {title: 'Path Manager', url: '/company/paths/pages'},
    ]}


const BuilderLinks = {title: 'Builders',
    children: [
        {title: 'Build a Model', url: '/builders/landing'},
        {title: 'Create an SMA', url: '/builders/sma'},

    ]}


const ManagementLinkSet = {
    title: 'Portfolios',
    children: [
                {title: 'Portfolio Collection', url: '/portfolios'},
                {title: 'Portfolio Exchange', url: '/portfolios/exchange'},
                {title: 'Portfolio Paths', url:'/portfolios/paths'},
    ]
}

const ResearchLinkSet = {
    title: 'Research',
    children: [
        {title: 'Performance Comparison', url: '/performance/comparison'},
        {title: <div className={'flex'}>Stat Tables <div className={'text-indigo-600 py-0 text-xs font-bold rounded-md ml-1'}>+</div></div>, url: '/beta/comparison'},
        {title: 'Stock & ETF Screener', url:'/screener'},

    ]
}

const ClientLinkSet = {
    title: 'Clients',
    children: [
        {title: 'Client Accounts', url: '/clients'},
        {title: 'IQ Pages', url: '/pages'},
    ]
}


const UtilityLinkSet = {
    title: 'Resources',
    children: [
        {title: 'Files', url: '/files'},
        {title: 'Learn FINIAT', url: '/resources'},
    ]
}



const ExperimentalLinkSet = {
    title: 'Experimental',
    children: [
                {title: 'Experiments', url: '/experiments/home'},
                {title: 'Factor View', url: '/markets/factors'},
                {title: 'Chart Launcher', url: '/experiments/charts/launcher'},
                {title: 'Chat', url: '/inference/chat'},
                {title: 'Analysis Options', url: '/beta/analysis/options'},

    ]
}



const ApplicationManager = ({widgets})=>{
    const bp = useBreakpoint();
    const [showDrawer, setShowDrawer] = useState(false);
    const linkMap = [
        {...ManagementLinkSet},
        {...ResearchLinkSet},
        {...CompanyLinks},
        {...BuilderLinks},
        {...ClientLinkSet},
        {...UtilityLinkSet},
        {...ExperimentalLinkSet},
    ]

    const AppCard = ()=>(
        <Card bordered={false} className={'px-6 xs:py-6 xl:py-6 2xl:py-10 h-screen bg-transparent'}>
            <Alert color={'primary'}
                   variant={'outlined'}
                   className={'bg-transparent'}
                   style={{background:'transparent', border:'none'}}
                   icon={<Boxes size={28}/>}>
                <AlertTitle style={{fontSize: '1.4rem'}}>
                    Classic Apps
                </AlertTitle>
            </Alert>
            <Divider/>
            <Widgets widgets={widgets} span={6} center={true}/>
        </Card>
    )

    return (
        <div className={'h-screen overflow-hidden w-full bg-gray-50'}>
            <Row justify={'space-between'}>
                <Col xs={24} xxl={16}>
                    <Card bordered={false} className={'xs:p-6 xl:p-8 2xl:p-10 bg-gray-50'}>
                        <Row gutter={16} justify={'start'}>
                            {linkMap.map((link, index) => (
                                <Col>
                                    <MenuTag key={index} title={link.title} childrenLinks={link.children} />
                                </Col>
                            ))}
                            {!bp.xxl && (
                                <Col>
                                    <Button variant={'contained'} className={'pill'} onClick={()=>setShowDrawer(true)}>
                                        Show Apps
                                    </Button>
                                </Col>
                            )}
                        </Row>
                        <Divider/>
                        <div className={'py-4 px-6 bg-white rounded-md shadow-sm'}>
                            <Row justify={'space-between'} gutter={[16, 32]}>
                                {linkMap.map((link, index) => (
                                    <Col xs={12} xl={8}>
                                        <LinkTree key={index} data={[link]} />
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </Card>
                </Col>
                {bp.xxl && (
                    <Col xs={24} xxl={8} className={'h-screen'}>
                        <AppCard/>
                    </Col>
                )}
            </Row>
            {!bp.xxl && (
                <Drawer width={700} open={showDrawer} onClose={()=>setShowDrawer(false)}>
                    <AppCard/>
                </Drawer>
            )}
        </div>
    )
}
export default ApplicationManager;